import React from 'react';
import './LoadingSkeleton.css';

export const CardSkeleton = () => (
  <div className="skeleton-card">
    <div className="skeleton-line skeleton-title"></div>
    <div className="skeleton-line skeleton-text"></div>
    <div className="skeleton-line skeleton-text short"></div>
  </div>
);

export const ButtonSkeleton = () => (
  <div className="skeleton-button"></div>
);

export const ListSkeleton = ({ count = 3 }) => (
  <div className="skeleton-list">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="skeleton-list-item">
        <div className="skeleton-line"></div>
        <div className="skeleton-line short"></div>
      </div>
    ))}
  </div>
);

export const PhotoGridSkeleton = () => (
  <div className="skeleton-photo-grid">
    {Array.from({ length: 6 }).map((_, i) => (
      <div key={i} className="skeleton-photo"></div>
    ))}
  </div>
);

const LoadingSkeleton = ({ type = 'card', count }) => {
  switch (type) {
    case 'card':
      return <CardSkeleton />;
    case 'button':
      return <ButtonSkeleton />;
    case 'list':
      return <ListSkeleton count={count} />;
    case 'photo-grid':
      return <PhotoGridSkeleton />;
    default:
      return <CardSkeleton />;
  }
};

export default LoadingSkeleton;







